var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationSearch = function SvgLocationSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.712V3.75a.75.75 0 0 1 1.5 0v1.962A6.089 6.089 0 0 1 17.788 11h1.962a.75.75 0 0 1 0 1.5h-1.962a6.089 6.089 0 0 1-5.288 5.288v1.962a.75.75 0 0 1-1.5 0v-1.962A6.089 6.089 0 0 1 5.712 12.5H3.75a.75.75 0 0 1 0-1.5h1.962A6.089 6.089 0 0 1 11 5.712zm.744 1.455a4.583 4.583 0 1 0 .012 0h-.012z"
  })));
};
export default SvgLocationSearch;